import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import baseUrl from "../../API/BaseUrl";

const initialState = {
    allorders:[],
    orderDetails:[],
    PayCase:[],
    DeliverCase:[],
    isLoading: true,
    isSuccess: true,
    errorMessage: ""
}
// get all  orders 
export const getAllOrders = createAsyncThunk("orders/getall", async (querySelector) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.get(`/api/v1/orders?${querySelector}`, config);
        return res;
    } catch (error) {
        return error;
    }
})

// get order details
export const getOrderDetails = createAsyncThunk("order/getOne", async (id) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.get(`/api/v1/orders/${id}`, config);
        return res;
    } catch (error) {
        return error;
    }
})


// change paid case
export const ChangePaidCase = createAsyncThunk("order/PayCase", async (id) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.put(`/api/v1/orders/${id}/pay`,id, config);
        return res;
    } catch (error) {
        return error;
    }
})

// change deliver case
export const ChangeDeliverCase = createAsyncThunk("order/DeliverCase", async (id) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.put(`/api/v1/orders/${id}/deliver`,id, config);
        return res;
    } catch (error) {
        return error;
    }
})

const OrderSlice = createSlice({
    name: "orders",
    initialState,
    reducers: {},
    extraReducers: {
        [getAllOrders.pending]: (state, action) => {
            state.isLoading = true;
        },
        [getAllOrders.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.allorders = action.payload;
        },
        [getAllOrders.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        },
        [getOrderDetails.pending]: (state, action) => {
            state.isLoading = true;
        },
        [getOrderDetails.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.orderDetails = action.payload;
        },
        [getOrderDetails.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        },
        [ChangePaidCase.pending]: (state, action) => {
            state.isLoading = true;
        },
        [ChangePaidCase.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.PayCase = action.payload;
        },
        [ChangePaidCase.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        },
        [ChangeDeliverCase.pending]: (state, action) => {
            state.isLoading = true;
        },
        [ChangeDeliverCase.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.DeliverCase = action.payload;
        },
        [ChangeDeliverCase.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        }
    }
})

export default OrderSlice.reducer;